import { Component, input, output } from '@angular/core';
import { RidWordList } from '../rid-word-list/rid-word-list';
import { TRidWord } from '../rid-word/rid-word';

@Component({
  selector: 'rid-word-matrix',
  imports: [RidWordList],
  templateUrl: './rid-word-matrix.html',
  host: {
    class: 'grid grid-cols-1',
  },
})
export class RidWordMatrix {
  matrix = input.required<(string | TRidWord)[][]>();

  selectionChanged = output<{ kind: 'ADDED' | 'REMOVED'; index: [col: number, row: number] }>();
}
